"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.creditRepayReducer = exports.createLedgerReducer = exports.fetchTbpBillAmountReducer = exports.fetchLatestLedgerEntryReducer = exports.fetchAllLedgerEntryReducer = exports.creditRepaySlice = exports.createLedgerSlice = exports.fetchTbpBillAmountSlice = exports.fetchLatestLedgerEntrySlice = exports.fetchAllLedgerEntrySlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const ledgerAction_1 = require("./ledgerAction");
const fetchInitialState = {
    loading: false,
    error: false,
    errorMessage: null,
    data: [],
};
const createInitialState = {
    loading: false,
    error: false,
    errorMessage: null,
    data: [],
};
exports.fetchAllLedgerEntrySlice = (0, toolkit_1.createSlice)({
    name: "ledger/fetchAllLedgerEntry",
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(ledgerAction_1.fetchAllLedgerEntry.pending, (state) => {
            state.loading = true;
            state.error = false;
            state.data = [];
            state.errorMessage = null;
        });
        builder.addCase(ledgerAction_1.fetchAllLedgerEntry.fulfilled, (state, action) => {
            state.loading = false;
            state.error = false;
            state.data = action.payload;
            state.errorMessage = null;
        });
        builder.addCase(ledgerAction_1.fetchAllLedgerEntry.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.data = [];
            state.errorMessage = action.error.message;
        });
    }
});
exports.fetchLatestLedgerEntrySlice = (0, toolkit_1.createSlice)({
    name: "ledger/fetchLatestLedgerEntry",
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(ledgerAction_1.fetchLatestLedgerEntry.pending, (state) => {
            state.loading = true;
            state.error = false;
            state.data = [];
            state.errorMessage = null;
        });
        builder.addCase(ledgerAction_1.fetchLatestLedgerEntry.fulfilled, (state, action) => {
            state.loading = false;
            state.error = false;
            state.data = action.payload;
            state.errorMessage = null;
        });
        builder.addCase(ledgerAction_1.fetchLatestLedgerEntry.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.data = [];
            state.errorMessage = action.error.message;
        });
    }
});
exports.fetchTbpBillAmountSlice = (0, toolkit_1.createSlice)({
    name: "ledger/fetchTbpBillAmount",
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(ledgerAction_1.fetchTbpBillAmount.pending, (state) => {
            state.loading = true;
            state.error = false;
            state.data = [];
            state.errorMessage = null;
        });
        builder.addCase(ledgerAction_1.fetchTbpBillAmount.fulfilled, (state, action) => {
            state.loading = false;
            state.error = false;
            state.data = action.payload;
            state.errorMessage = null;
        });
        builder.addCase(ledgerAction_1.fetchTbpBillAmount.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.data = [];
            state.errorMessage = action.error.message;
        });
    }
});
exports.createLedgerSlice = (0, toolkit_1.createSlice)({
    name: "ledger/create",
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(ledgerAction_1.create.pending, (state) => {
            state.loading = true;
            state.error = false;
            state.data = [];
            state.errorMessage = null;
        });
        builder.addCase(ledgerAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.error = false;
            state.data = action.payload;
            state.errorMessage = null;
        });
        builder.addCase(ledgerAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.data = [];
            state.errorMessage = action.error.message;
        });
    }
});
exports.creditRepaySlice = (0, toolkit_1.createSlice)({
    name: "ledger/creditRepay",
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(ledgerAction_1.creditRepay.pending, (state) => {
            state.loading = true;
            state.error = false;
            state.data = [];
            state.errorMessage = null;
        });
        builder.addCase(ledgerAction_1.creditRepay.fulfilled, (state, action) => {
            state.loading = false;
            state.error = false;
            state.data = action.payload;
            state.errorMessage = null;
        });
        builder.addCase(ledgerAction_1.creditRepay.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
            state.data = [];
            state.errorMessage = action.error.message;
        });
    }
});
exports.fetchAllLedgerEntryReducer = exports.fetchAllLedgerEntrySlice.reducer;
exports.fetchLatestLedgerEntryReducer = exports.fetchLatestLedgerEntrySlice.reducer;
exports.fetchTbpBillAmountReducer = exports.fetchTbpBillAmountSlice.reducer;
exports.createLedgerReducer = exports.createLedgerSlice.reducer;
exports.creditRepayReducer = exports.creditRepaySlice.reducer;
